import { Box, styled } from '@withjoy/joykit';

export { getAmountButtonOverrides } from '@shared/utils/style/buttonOverrides';

export const StyledSelectWrapper = styled(Box)`
  [role='combobox'] {
    div:after,
    input:enabled:hover {
      border-color: ${({ theme }) => theme.colors.mono14};
    }
  }
`;

export const StyledAmountButtonsContainer = styled(Box)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
`;
